
import UMUM from "../../library/umum.js";

export default {
    data() {
        return {
            list_data: [],
            form: {
                nama_kegiatan: '',
                file_name: null,
            },
            UMUM: UMUM,
            btn_add: false,
            btn_edit: false,
            mdl_add: false,
            mdl_edit: false,
            mdl_delete: false,
            mdl_image: false,
            selectedImage: null,
            cari_value: "",
            page_first: 1,
            page_last: 1,
            page_limit: 9,
            total: 0,
            tipe: null,
            file_path: this.$store.state.url.URL_APP + "uploads/",
        }
    },

    methods: {

       
        openEdit(data) {
            this.form = {
                id: data.id || null,
                nama_kegiatan: data.nama_kegiatan || '',
                file_name: data.file_name || null,
            }
            this.fileBaru = null
            this.mdl_edit = true
        },


        openDelete(data) {
            this.form = { id: data.id }
            this.mdl_delete = true
        },

        openImage(src) {
            this.selectedImage = src
            this.mdl_image = true
        },

        resetForm() {
            this.form = {
                id: null,
                nama_kegiatan: '',
                file_name: null,
            }
            this.fileBaru = null
        },

        async getView() {
            try {
                this.$store.commit("shoWLoading");

                const res = await fetch(this.$store.state.url.FOTO + "getview", {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        data_ke: this.page_first,
                        cari_value: this.cari_value,
                        page_limit: this.page_limit
                    })
                });

                const res_data = await res.json();
                this.list_data = res_data.data || [];
                this.total = res_data.total || 0;
                this.page_last = Math.ceil(this.total / this.page_limit) || 1;
                this.$store.commit("hideLoading");
            } catch (err) {
                console.error("❌ Error getView foto Donor:", err);
                this.$store.commit("hideLoading");
            }
        },

        addData() {
            this.btn_add = true;
            const formData = new FormData();

            formData.append("nama_kegiatan", this.form.nama_kegiatan);
            if (this.form.file_name) {
                formData.append("file_name", this.form.file_name);
            }

            fetch(this.$store.state.url.FOTO + "addData", {
                method: "POST",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            })
                .then(res => res.json())
                .then(res_data => {
                    this.btn_add = false;
                    if (res_data.success) {
                        this.$q.notify({ type: "positive", message: res_data.message || "Sukses menambah foto" })
                        this.getView();
                        this.mdl_add = false;
                        this.resetForm();
                    } else {
                        this.$q.notify({ type: "negative", message: res_data.message || "Gagal menambah foto" })
                    }
                })
                .catch(err => {
                    this.btn_add = false;
                    console.error("❌ Error addData Foto:", err);
                    this.$q.notify({ type: "negative", message: "Terjadi kesalahan server" })
                })
        },

        async updateData() {
            try {
                this.btn_edit = true;
                const formData = new FormData();
                formData.append("id", this.form.id);
                formData.append("nama_kegiatan", this.form.nama_kegiatan);
                formData.append("tanggal_mulai", this.form.tanggal_mulai);
                formData.append("tanggal_selesai", this.form.tanggal_selesai);
                formData.append("jam", this.form.jam);
                formData.append("lokasi", this.form.lokasi);
                formData.append("map_link", this.form.map_link || '');
                formData.append("keterangan", this.form.keterangan || '');
                formData.append("jumlah_terdaftar", this.form.jumlah_terdaftar != null ? this.form.jumlah_terdaftar : '');
                formData.append(
                    "status",
                    typeof this.form.status === "object"
                        ? this.form.status.value
                        : this.form.status
                );


                if (this.fileBaru) {
                    // user upload file baru pada edit
                    formData.append("file_name", this.fileBaru);
                } else {
                    // tidak upload baru -> kirim nama file lama agar backend tahu tetap memakai file lama
                    formData.append("file_name", this.form.file_name || '');
                }

                const res = await fetch(this.$store.state.url.FOTO + "editData", {
                    method: "POST",
                    headers: {
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: formData
                });

                const result = await res.json();
                this.btn_edit = false;
                if (result.success) {
                    this.$q.notify({ type: "positive", message: result.message || "Sukses update foto" })
                    this.mdl_edit = false;
                    this.getView();
                } else {
                    this.$q.notify({ type: "negative", message: result.message || "Gagal update foto" })
                }
            } catch (err) {
                this.btn_edit = false;
                console.error("❌ Error updateData foto Donor:", err);
                this.$q.notify({ type: "negative", message: "Gagal update data" })
            }
        },

        removeData() {
            fetch(this.$store.state.url.FOTO + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id: this.form.id })
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.$q.notify({ type: "positive", message: res_data.message || 'Sukses menghapus foto' })
                        this.getView()
                    } else {
                        this.$q.notify({ type: "negative", message: res_data.message || 'Data tidak ditemukan' })
                    }
                })
                .catch(err => {
                    console.error("❌ Error removeData foto Donor:", err);
                    this.$q.notify({ type: "negative", message: 'Terjadi kesalahan server' })
                })
        },

        cari_data() {
            this.page_first = 1;
            this.getView();
        },

        indexing(index) {
            return ((this.page_first - 1) * this.page_limit) + index;
        },
    },

    mounted() {
        this.getView();
    }
}
